<template>
  <v-container fluid class="nsr-items">
    <v-row class="flex-grow-0">
      <h3>{{ $t("nsr_item.title") }}</h3>
      <v-btn color="primary" class="ml-4" small @click="createItem">
        <v-icon>mdi-plus</v-icon>
        New
      </v-btn>
      <v-btn
        v-if="canEditConfig"
        color="primary"
        class="ml-4"
        small
        @click="editNsrConfig"
      >
        Configuration
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="flex-grow-1">
      <NsrItemList
        full-height
        :refresh-trigger.sync="refreshTrigger"
      ></NsrItemList>
    </v-row>
  </v-container>
</template>
<script>
import NsrItemList from "@/components/nsr/NsrItemList";
import { ref } from "@vue/composition-api/dist/vue-composition-api";
import CreateNsrItemDialog from "@/components/nsr/CreateNsrItemDialog";
import NsrConfigDialog from "@/components/nsr/NsrConfigDialog.vue";
import { computed } from "@vue/composition-api";
import { USER_TYPE, PERMISSIONS, SPECIAL_PERMISSIONS } from "@/constants";

export default {
  name: "Nsr",
  components: { NsrItemList },
  setup(props, { root }) {
    const refreshTrigger = ref(false);
    const canEditConfig = computed(() => {
      if (!root.$store.getters.account) return false;
      return (
        [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].includes(
          root.$store.getters.account.type
        ) ||
        root.$store.getters.account.permissions.includes(PERMISSIONS.MANAGE_NSR)
      );
    });

    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const createItem = async function () {
      const needRefresh = await root.$dialog.showAndWait(CreateNsrItemDialog, {
        persistent: true,
        showClose: false,
      });

      if (needRefresh) {
        refresh();
      }
    };

    const editNsrConfig = async function () {
      const needRefresh = await root.$dialog.showAndWait(NsrConfigDialog, {
        persistent: true,
        showClose: false,
      });
    };

    return {
      refreshTrigger,
      refresh,

      createItem,
      editNsrConfig,
      canEditConfig,
    };
  },
};
</script>

<style lang="less">
.nsr-items {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
